//graphql/mutations.js
import { gql } from "@apollo/client";

export const CREATE_TRANSACTION = gql`
  mutation createTransaction(
    $transactionInput: TransactionInput!
  ) {
    createTransaction(
      transactionInput: $transactionInput
    ) {
      id
      sum
      datetime
      type
      description
      comment
      project {
        id
        name
      }
      receipt {
        path
      }
    }
  }
`;